"use strict";

var Util = require('../../util');

module.exports = function (field) {
  if (Util.isArray(field)) {
    return field;
  }

  if (Util.isString(field)) {
    return field.split('*');
  }

  return [field];
};


//////////////////
// WEBPACK FOOTER
// ./src/geom/util/parse-fields.js
// module id = 350
// module chunks = 0 1 2